/**
 * Abstract transport interface for chat session streaming.
 * Provides a consistent contract for connect/disconnect/resume/send/cancel.
 * onEvent may synchronously return { completed: boolean } after applying the
 * projection. This decision covers live events and replacement bootstraps and
 * takes precedence over raw terminal payloads (e.g. a pending optimistic send).
 * Throwing from onEvent leaves the transport cursor unacknowledged for retry.
 */
export class ChatTransport {
  connect(sessionId, options) {
    throw new Error("not implemented");
  }
  disconnect() {
    throw new Error("not implemented");
  }
  resume(sessionId, lastEventId) {
    throw new Error("not implemented");
  }
  send(sessionId, message) {
    throw new Error("not implemented");
  }
  cancel(sessionId) {
    throw new Error("not implemented");
  }
}
